import React from "react";
import { Route, withRouter, Switch } from "react-router-dom";
import routes from "./../../config/page-route.jsx";
import { PageSettings } from "./../../config/page-settings.js";
import PrivateRoute from "../../config/protectedRoute";

function setTitle(path, routeArray) {
  var pageTitle;
  for (var i = 0; i < routeArray.length; i++) {
    if (routeArray[i].path === path) {
      pageTitle = "Ania Management | " + routeArray[i].title;
    }
  }
  document.title = pageTitle ? pageTitle : "Ania Management";
}

class Content extends React.Component {
  componentDidMount() {
    setTitle(this.props.history.location.pathname, routes);
  }
  componentWillMount() {
    this.props.history.listen(() => {
      setTitle(this.props.history.location.pathname, routes);
    });
  }

  render() {
    return (
      <PageSettings.Consumer>
        {({
          pageContentFullWidth,
          pageContentClass,
          pageContentInverseMode,
        }) => (
          <div
            className={
              "content " +
              (pageContentFullWidth ? "content-full-width " : "") +
              (pageContentInverseMode ? "content-inverse-mode " : "") +
              pageContentClass
            }
          >
              <Switch>
                {routes.map((route, index) =>
                  route.protected ? (
                    <PrivateRoute
                      key={index}
                      path={route.path}
                      exact={route.exact}
                      component={route.component}
                    />
                  ) : (
                    <Route
                      key={index}
                      path={route.path}
                      exact={route.exact}
                      component={route.component}
                    />
                  )
                )}
              </Switch>
          </div>
        )}
      </PageSettings.Consumer>
    );
  }
}

export default withRouter(Content);
